import axios from "axios";
import router from "@/router";
import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";
import { RUNTIME_ENV } from "@/runtimeEnv";

const baseUrl = RUNTIME_ENV.VUE_APP_API_URL + "base/api/v1/";
const saleUrl = RUNTIME_ENV.VUE_APP_API_URL + "sale/api/v1/";

axios.defaults.baseURL = saleUrl;
axios.defaults.headers.common["Authorization"] = localStorage[getStorageKey()];
axios.defaults.headers.common["Content-Type"] = "application/json";
const savedBranchId = localStorage.getItem("branchId");
if (savedBranchId) {
  axios.defaults.headers.common["branchId"] = savedBranchId;
}
function getStorageKey() {
  const hostname = window.location.hostname;
  if (hostname === "localhost" || /^(\d{1,3}\.){3}\d{1,3}$/.test(hostname)) {
    return "mitaCustomerToken";
  } else {
    return hostname.split(".")[0];
  }
}

export default {
  getRoute({ dispatch, commit }, data) {
    if (axios.defaults.baseURL != baseUrl) {
      axios.defaults.baseURL = baseUrl;
    }
    axios
      .get("Account/GetRoute?clubUrl=" + data)
      .then((res) => {
        commit("setRouteName", res.data.data);
        axios.defaults.baseURL = saleUrl;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },
  sendCode({ dispatch, commit }, data) {
    commit("setCheckCode", false);
    commit("setLoginCheck", true);
    axios
      .post("customer/Login/SendOtp", data)
      .then((res) => {
        commit("setCheckCode", res.data);
        commit("setLoginCode", res.data);

        const branchData = res.data.data;

        if (branchData) {
          localStorage.setItem("branchId", branchData);
          axios.defaults.headers.common["branchId"] = branchData;
        }

        commit("setLoginBranch", branchData);
        commit("setSuccess", alert.success.sentCode, { root: true });
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoginCheck", false);
        }, 800);
      });
  },

  login({ dispatch, commit }, data) {
    commit("setLoginCheck", true);
    axios
      .post("customer/Login/Login", data)
      .then((res) => {
        commit("authUser", res.data.data);
        const storageKey = getStorageKey();
        localStorage.setItem(storageKey, res.data.data.token);
        axios.defaults.headers.common["Authorization"] = res.data.data.token;
        const redirectPath = router.history.current.query.redirect;
        if (redirectPath) {
          const redirectId = router.history.current.query.id;
          router.push({ name: redirectPath, params: { id: redirectId } });
        } else {
          router.push({ name: "Home" });
        }
        setTimeout(() => {
          commit("setSuccess", alert.success.login, { root: true });
        }, 800);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoginCheck", false);
        }, 800);
      });
  },

  logout({ commit }, data) {
    const storageKey = getStorageKey();
    localStorage.removeItem(storageKey);
    localStorage.removeItem("branchId");
    axios.defaults.headers.common["Authorization"] = "";
    delete axios.defaults.headers.common["branchId"];
    commit("clearAuth");
    if (data && data.redirect) {
      router.push({ name: "Login", query: { redirect: data.redirect } });
    } else {
      router.push({ name: "Login" });
    }
  },

  getCurrentUser({ dispatch, commit }) {
    commit(
      "setLoading",
      { status: 1, message: label.caption.loading },
      { root: true },
    );
    axios
      .get("customer/Profile")
      .then((res) => {
        commit("setCurrentUser", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoading", { status: 0, message: "" }, { root: true });
        }, 500);
      });
  },

  editProfile({ commit, dispatch }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .put("customer/Profile", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.editProfile,
            redirect: "Profile",
          },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editProfileAvatar({ dispatch }, data) {
    axios
      .post("profile/avatar", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          { server: res, message: alert.success.changeAvatar, redirect: false },
          { root: true },
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  // Alert and Errors Handler ------------------------------------------------------
  successPOSTHandler({ commit }, data) {
    if (data.server && data.server.status === 200) {
      commit("setSuccess", data.message, { root: true });
      commit("setPostCheck", true, { root: true });
      setTimeout(() => {
        commit("setPostCheck", false, { root: true });
      }, 800);
      if (data.redirect) {
        setTimeout(() => {
          router.push({ name: data.redirect });
        }, 2500);
      }
    } else if (data.server.data && data.server.data.message != "") {
      commit("setError", data.server.data.message, { root: true });
      commit("setPostCheck", false, { root: true });
    } else {
      commit("setError", alert.error.server, { root: true });
      commit("setPostCheck", false, { root: true });
    }
  },

  successPOSTHandlerSimple({ commit }, data) {
    if (data.server && data.server.status === 200) {
      commit("setSuccess", data.message, { root: true });
    } else if (data.server.data && data.server.data.message != "") {
      commit("setError", data.server.data.message, { root: true });
    } else {
      commit("setError", alert.error.server, { root: true });
    }
  },

  errorPOSTHandler({ dispatch, commit }, data) {
    commit("setPostCheck", false, { root: true });
    if (data.response && data.response.status === 403) {
      commit("setError", alert.error.access, { root: true });
    } else if (data.response && data.response.status === 401) {
      dispatch("logout", null, { root: true });
    } else if (data.response.data.message && data.response.data.message != "") {
      commit("setError", data.response.data.message, { root: true });
    } else {
      commit("setError", alert.error.server, { root: true });
    }
  },

  errorGETHandler({ dispatch, commit }, data) {
    commit("setPostCheck", false, { root: true });
    if (data.response && data.response.status === 403) {
      router.push({ name: "Page403" });
    } else if (data.response && data.response.status === 401) {
      dispatch("logout", null, { root: true });
    } else if (data.response.data.message && data.response.data.message != "") {
      commit("setError", data.response.data.message, { root: true });
    } else {
      commit("setError", alert.error.server, { root: true });
    }
  },
};
